import React, { useCallback, useEffect } from 'react'
import { useQueryClient } from 'react-query'
import { useLocation } from 'react-router'

import { AlertDrawer } from 'features/alerts/components/alert-drawer/AlertDrawer'
import { AlertResponse, useAlertService } from 'features/alerts/service'
import { useAlertUIStore } from 'features/alerts/store'
import { useProjectStore } from 'features/project/store'
import { useCurrentRoute } from 'hooks'
import { ProjectState } from 'types/project'

export const CreateAlertDrawer: React.FC = () => {
  const location = useLocation()
  const alertService = useAlertService()
  const projectId = useProjectStore((state: ProjectState) => state.projectId)
  const route = useCurrentRoute()
  const details = useProjectStore((state: ProjectState) => state.details)
  const isAlertDrawerOpen = useAlertUIStore((state) => state.isAlertDrawerOpen)
  const setIsAlertDrawerOpen = useAlertUIStore(
    (state) => state.setIsAlertDrawerOpen,
  )
  const alertRequest = useAlertUIStore((state) => state.alertRequest)

  useEffect(() => {
    setIsAlertDrawerOpen(false)
  }, [location.pathname, setIsAlertDrawerOpen])

  const queryClient = useQueryClient()
  const onAlertUpserted = useCallback(
    (upsertedAlert: AlertResponse) => {
      queryClient.setQueryData(
        ['alerts', projectId],
        (cachedAlerts: AlertResponse[] | undefined) => {
          if (!cachedAlerts) return [upsertedAlert]
          const otherAlerts = cachedAlerts.filter(
            (alert) => alert.alert.id !== upsertedAlert.alert.id,
          )
          return [...otherAlerts, upsertedAlert]
        },
      )
    },
    [queryClient, projectId],
  )

  return (
    <AlertDrawer
      projectId={projectId}
      route={route}
      isAlertDrawerOpen={isAlertDrawerOpen}
      setIsAlertDrawerOpen={setIsAlertDrawerOpen}
      alertRequest={alertRequest}
      isPublicViewer={details?.role === 'public_viewer'}
      onAlertUpserted={onAlertUpserted}
      alertService={alertService}
    />
  )
}
